module.exports = __webpack_public_path__ + "static/media/gauge_white.dd610cd7.png";